const imageSizeQueryParams = (height = 400, width = 400) =>
  `?height=${height}&width=${width}`;

export default imageSizeQueryParams;
